module.exports = __webpack_public_path__ + "img/7fa87526d9a203fe03f75c754e9aaa3f.png";